"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BurnchainApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class BurnchainApi extends runtime.BaseAPI {
    /**
     * Get a list of recent burnchain (e.g. Bitcoin) reward recipients with the associated amounts and block info
     * Get recent burnchain reward recipients
     */
    async getBurnchainRewardListRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/burnchain/rewards`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.BurnchainRewardListResponseFromJSON(jsonValue));
    }
    /**
     * Get a list of recent burnchain (e.g. Bitcoin) reward recipients with the associated amounts and block info
     * Get recent burnchain reward recipients
     */
    async getBurnchainRewardList(requestParameters, initOverrides) {
        const response = await this.getBurnchainRewardListRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get a list of recent burnchain (e.g. Bitcoin) rewards for the given recipient with the associated amounts and block info
     * Get recent burnchain reward for the given recipient
     */
    async getBurnchainRewardListByAddressRaw(requestParameters, initOverrides) {
        if (requestParameters.address === null || requestParameters.address === undefined) {
            throw new runtime.RequiredError('address', 'Required parameter requestParameters.address was null or undefined when calling getBurnchainRewardListByAddress.');
        }
        const queryParameters = {};
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/burnchain/rewards/{address}`.replace(`{${"address"}}`, encodeURIComponent(String(requestParameters.address))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.BurnchainRewardListResponseFromJSON(jsonValue));
    }
    /**
     * Get a list of recent burnchain (e.g. Bitcoin) rewards for the given recipient with the associated amounts and block info
     * Get recent burnchain reward for the given recipient
     */
    async getBurnchainRewardListByAddress(requestParameters, initOverrides) {
        const response = await this.getBurnchainRewardListByAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Array of the Bitcoin addresses that would validly receive PoX commitments.
     * Get recent reward slot holders
     */
    async getBurnchainRewardSlotHoldersRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/burnchain/reward_slot_holders`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.BurnchainRewardSlotHolderListResponseFromJSON(jsonValue));
    }
    /**
     * Array of the Bitcoin addresses that would validly receive PoX commitments.
     * Get recent reward slot holders
     */
    async getBurnchainRewardSlotHolders(requestParameters, initOverrides) {
        const response = await this.getBurnchainRewardSlotHoldersRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Array of the Bitcoin addresses that would validly receive PoX commitments.
     * Get recent reward slot holder entries for the given address
     */
    async getBurnchainRewardSlotHoldersByAddressRaw(requestParameters, initOverrides) {
        if (requestParameters.address === null || requestParameters.address === undefined) {
            throw new runtime.RequiredError('address', 'Required parameter requestParameters.address was null or undefined when calling getBurnchainRewardSlotHoldersByAddress.');
        }
        const queryParameters = {};
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/burnchain/reward_slot_holders/{address}`.replace(`{${"address"}}`, encodeURIComponent(String(requestParameters.address))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.BurnchainRewardSlotHolderListResponseFromJSON(jsonValue));
    }
    /**
     * Array of the Bitcoin addresses that would validly receive PoX commitments.
     * Get recent reward slot holder entries for the given address
     */
    async getBurnchainRewardSlotHoldersByAddress(requestParameters, initOverrides) {
        const response = await this.getBurnchainRewardSlotHoldersByAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Get the total burnchain (e.g. Bitcoin) rewards for the given recipient
     * Get total burnchain rewards for the given recipient
     */
    async getBurnchainRewardsTotalByAddressRaw(requestParameters, initOverrides) {
        if (requestParameters.address === null || requestParameters.address === undefined) {
            throw new runtime.RequiredError('address', 'Required parameter requestParameters.address was null or undefined when calling getBurnchainRewardsTotalByAddress.');
        }
        const queryParameters = {};
        const headerParameters = {};
        const response = await this.request({
            path: `/extended/v1/burnchain/rewards/{address}/total`.replace(`{${"address"}}`, encodeURIComponent(String(requestParameters.address))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => models_1.BurnchainRewardsTotalFromJSON(jsonValue));
    }
    /**
     * Get the total burnchain (e.g. Bitcoin) rewards for the given recipient
     * Get total burnchain rewards for the given recipient
     */
    async getBurnchainRewardsTotalByAddress(requestParameters, initOverrides) {
        const response = await this.getBurnchainRewardsTotalByAddressRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
exports.BurnchainApi = BurnchainApi;
//# sourceMappingURL=BurnchainApi.js.map